class CartCount extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.onCartChanged = this.onCartChanged.bind(this)
    this.onPageShow = this.onPageShow.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.onCartChanged,
    )

    window.addEventListener('pageshow', this.onPageShow)
  }

  onPageShow (event) {
    fetch(`${window.Shopify.routes.root}?sections=push-cart-count`, {
      credentials: 'same-origin',
    })
      .then(res => (res.ok ? res.json() : null))
      .then(sections => {
        const html = sections?.['push-cart-count']
        if (!html) return

        const newCartTotal = Number.parseInt(this.getCount(html), 10) || 0
        this.textContent = newCartTotal
        this.setAttribute('aria-hidden', newCartTotal === 0)
      })
      .catch(error => console.error('cart-count pageshow failed', error))
  }

  /**
   * @param {CustomEvent} e
   *
   * @returns {void}
   */
  onCartChanged (e) {
    const { state } = e.detail
    if (!state) return
    if (!state.sections) return

    if (!('push-cart-count' in state.sections)) return

    const newCartTotal = parseInt(
      this.getCount(state.sections['push-cart-count']),
    )
    this.textContent = newCartTotal
    this.setAttribute('aria-hidden', newCartTotal === 0)
  }

  /**
   * @param {string} html
   *
   * @returns {string}
   */
  getCount (html) {
    const DOM = window.BAO.sectionRenderer.convertToDOM(html)
    const countEl = DOM.querySelector('#push-cart-count')

    if (countEl) return countEl.textContent

    // fallback: section contains only the count text
    return DOM.textContent.trim()
  }
}

if (!customElements.get('cart-count')) {
  customElements.define('cart-count', CartCount)
}
